module.exports = __webpack_public_path__ + "static/media/agriculture.b48b80d2.svg";